import _ from 'lodash';
import uuid from 'uuid-random';
import React from 'react';
import ReactDOM from 'react-dom';
import { Widget, DownloadWidget, ConnectShowData } from '../../index';
import { getNodesFromContainerFromTypes } from '../Util';
import WindowManager from './WindowManager';
import {
  ASYNC_DOWNLOAD_DISPATCHER_PARTIAL_MATCH_SPLITTER,
  ASYNC_DOWNLOAD_DISPATCHER_PREFIX
} from '../../dispatcher/config/Constants';

/**
 * Creates and removes Widgets from dom.
 */
abstract class Connect {
  private static TagPrefix: string = 'div_';
  private static AsyncDownloadFramesSelector: string = `[id^=${ASYNC_DOWNLOAD_DISPATCHER_PREFIX}${ASYNC_DOWNLOAD_DISPATCHER_PARTIAL_MATCH_SPLITTER}]`;
  private static focusRelation: any = {};

  static show = ({ render, props, children }: ConnectShowData) => {
    const renderTo = document.getElementById('widgets') as HTMLElement;
    const id = `${Connect.TagPrefix}${props.id}`;
    const child = renderTo.getElementsByTagName(id)[0];

    if (!child) {
      if (render === 'DownloadWidget') {
        render = DownloadWidget;
      } else {
        render = Widget;
      }

      if (props.previousFocus) {
        if (_.isBoolean(props.previousFocus)) {
          props.previousFocus = uuid();
        }
        Connect.focusRelation[id] = props.previousFocus;
        WindowManager.setPreviousFocusToView();
      }
      const item = React.createElement(render, props, Array.isArray(children) ? children : []);
      let div = document.createElement(id);
      if (renderTo) {
        renderTo.appendChild(div);
      }
      ReactDOM.render(item, div);

      let element = document.getElementsByTagName(id)[0];
      if (element && element.children) {
        setTimeout(() => {
          const tabbableElements: any[] = getNodesFromContainerFromTypes(document.getElementsByTagName(id)[0], ['button', 'a', 'input'], [{
            name: 'tabindex'
          }]);
          if (Array.isArray(tabbableElements) && tabbableElements[0]) {
            tabbableElements[0].focus();
          }
        }, 1);
      }
      div = null;
    }
  };

  /**
   * Removes element from dom by tag name.
   * @param id
   */
  static remove = (id: string) => {
    let fullId: string = `${Connect.TagPrefix}${id}`;
    let child = document.getElementsByTagName(fullId)[0];
    if (child && child.parentElement) {
      child.parentElement.removeChild(child);
    }
    Connect.restorePreviousFocus(fullId);
    child = null;
  };

  /**
   * Removes all iframe elements from dom created for downloading files
   */
  static removeDownloadFrames = () => {
    let asyncDownloadFrames = document.querySelectorAll(Connect.AsyncDownloadFramesSelector);
    if (asyncDownloadFrames.length) {
      asyncDownloadFrames.forEach((frame) => {
        if (frame && frame.parentElement) {
          frame.parentElement.removeChild(frame);
        }
        frame = null;
      });
    }
  };

  private static restorePreviousFocus = (fullId: string) => {
    const previousFocusToDo = Connect.focusRelation[fullId];
    const previousFocusElement = document.querySelectorAll(`[previousWindowFocus="${previousFocusToDo}"]`)[0];
    if (previousFocusElement) {
      previousFocusElement.removeAttribute('previousWindowFocus');
      // @ts-ignore
      previousFocusElement.focus();
    }
    delete Connect.focusRelation[fullId];
  };
}

export default Connect;
